import { useQuery } from '@apollo/client/react';
import { type FunctionComponent } from 'react';
import { type ShopByLookPageQuery, type ShopByLookPageQueryVariables } from '../../../../__generated__/graphql-client-types';
import { MAX_PAGE_WIDTH } from '../../../../constants/breakpoints';
import { buildGTMProjectInteractionTracking } from '../../../../helpers/analytics/gtm/gtm-utils.helper';
import { SHOP_BY_LOOK_PAGE } from '../../../../queries/shop-by-look/shop-by-look.queries';
import { Link } from '../../../common-components/link/link.component';
import { CloudinaryImage } from '../../../images/cloudinary-image/cloudinary-image.component';

export const AboutPageInpiration: FunctionComponent = () => {
	const { data } = useQuery<ShopByLookPageQuery, ShopByLookPageQueryVariables>(SHOP_BY_LOOK_PAGE, {
		variables: {
			featuredInput: {
				tagFilterSets: { include: [{ name: 'featured', value: 'shop-by-look' }] },
				paging: { page: 1, pageSize: 4, useInfiniteScroll: false },
				showingFavoriteLooks: false
			},
			favoriteInput: {},
			trendsInput: {}
		}
	});
	const featuredLooks = data?.featuredLooks?.quickStarts || [];

	return (
		<section className="flex flex-column items-center w-100 ph3">
			<div style={{ maxWidth: MAX_PAGE_WIDTH }}>
				<div className="flex flex-column items gr1 mb5">
					<h2 className="ma0 pa0 f2 font-medium">Looking for inspiration?</h2>
					<p className="ma0 pa0 f6 f5-ns lh-copy theme-grey-dark">
						Discover the latest styles with rooms curated by professional designers.
					</p>
				</div>
				<div className="flex flex-column flex-row-ns justify-center items-end gc5">
					{featuredLooks.map((look) => (
						<Link
							url={`/account/projects/${look.projectId}/showcase`}
							key={look.id}
							className="theme-grey-darker mb4 mb0-ns w-25-ns"
							analyticsEvent={{
								data: buildGTMProjectInteractionTracking('projects-about-page', 'shop-by-look')
							}}>
							<div className="f3 font-medium mb2">{look.name}</div>
							<div className="theme-secondary bw1 bb mb3" style={{ width: 150 }} />
							<CloudinaryImage
								options={{ type: 'upload' }}
								publicID={look.featuredPhoto?.publicId}
								description={`A photo of a ${look.name}`}
								className="br3 w-100"
							/>
						</Link>
					))}
				</div>
			</div>
		</section>
	);
};
